(function(angular) {
    'use strict';

    window.THF.Angular.JoinForm.factory('thfFieldDefinitionContact', function() {
        return {
            'phoneNumber': {
                'label': 'Phone Number',
                'labelStyle': '',
                'name': 'phoneNumber',
                'defaultValue': [
                    {
                        'type': 'mobile',
                        'value': ''
                    }
                ],
                'placeholder': '',
                'tooltip': '',
                'validation': [
                    'required',
                    'requiredPhoneNumber'
                ]
            },
            'emailAddress': {
                'label': 'Email Address',
                'labelStyle': '',
                'name': 'emailAddress',
                'defaultValue': '',
                'placeholder': '',
                'tooltip': '',
                'validation': [
                    'required',
                    'thfEmail'
                ]
            },
            'communicationPreference': {
                'label': 'Communication Preference',
                'labelStyle': '',
                'name': 'communicationPreference',
                'defaultValue': '',
                'placeholder': '',
                'tooltip': '',
                'options': [
                    {'label': 'Electronically via Online Member Services (with email notification)', 'value': 'email'},
                    {'label': 'Electronically via Online Member Services (with SMS notification)', 'value': 'sms'},
                    {'label': 'Standard mail', 'value': 'mail'}
                ],
                'validation': [
                    'required'
                ]
            },
            'homeAddress': {
                'label': 'Home Address',
                'labelStyle': '',
                'name': 'homeAddress',
                'defaultValue': '',
                'placeholder': '',
                'tooltip': '',
                'onChange': function(newValue, oldValue, tabModel, formModel, field) {
                    if( formModel.cover.primaryState != newValue.State ) {
                        formModel.cover.primaryState = newValue.State;
                    }
                },
                'validation': [
                    'required',
                    'thfPreValidated'
                ]
            },
            'postalAddressSameAsHome': {
                'label': '',
                'labelStyle': '',
                'name': 'postalAddressSameAsHome',
                'defaultValue': '',
                'placeholder': '',
                'tooltip': '',
                'options': [
                    {'label': 'Postal address is the same as above', 'value': 'Y'}
                ],
                'validation': [
                    // 'required'
                ]
            },
            'postalAddress': {
                'label': 'Postal Address',
                'labelStyle': '',
                'name': 'postalAddress',
                'defaultValue': '',
                'placeholder': '',
                'tooltip': '',
                'validation': [
                    'required',
                    'thfPreValidated'
                ]
            }
        };
    });
})(angular);
